// Load all the channels within this directory.
// Channel files must be named *_channel.js.
const context = require.context('.', true, /_channel\.js$/)
context.keys().forEach((key) => context(key))
